"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterSubscribeFeedbackTypes = void 0;
var NewsletterSubscribeFeedbackTypes;
(function (NewsletterSubscribeFeedbackTypes) {
    NewsletterSubscribeFeedbackTypes["ALREADY_SUBSCRIBED"] = "alreadySubscribed";
    NewsletterSubscribeFeedbackTypes["ERROR"] = "error";
    NewsletterSubscribeFeedbackTypes["SUCCESS"] = "success";
})(NewsletterSubscribeFeedbackTypes || (exports.NewsletterSubscribeFeedbackTypes = NewsletterSubscribeFeedbackTypes = {}));
//# sourceMappingURL=NewsletterSubscribeTypes.js.map